






























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { cloneDeep, groupBy, uniqBy, sortBy, findIndex } from 'lodash-es';
import CouponGroup from './CouponGroup.vue';
import './style.scss';

@Component({
  components: {
    CouponGroup,
  },
})
export default class CouponList extends Vue {
  @Prop() loading!: boolean;
  @Prop() coupons!: Array<any>;
  @Prop() coupon!: any;
  @Prop({ default: false }) isLimit?: boolean;
  @Prop({ default: false }) withGroup?: boolean;
  @Prop() onSelectCoupon!: Function;
  public show: boolean = true;
  public couponString: string = '';
  public filterCoupons: object = {};
  public selectedCoupon: any = {};

  @Watch('coupon', { immediate: true })
  watchCoupon() {
    this.selectedCoupon = cloneDeep(this.coupon);
  }

  @Watch('coupons', { immediate: true })
  watchCoupons() {
    this.filterCoupons = this.groupCouponHandle(cloneDeep(this.coupons));
  }

  groupCouponHandle(coupons) {
    if (this.withGroup) {
      const groupSortOrder = ['REFERRAL COUPON', 'EVENT COUPON', 'KOL COUPON', 'MALL COUPON', 'MEMBER COUPON'];
      const sortCoupons = sortBy(coupons, x => findIndex(groupSortOrder, y => x.group === y));
      return groupBy(sortCoupons, 'group');
    } else {
      return { '': uniqBy(coupons, 'id') };
    }
  }
  filterCouponHandle() {
    if (this.couponString) {
      this.filterCoupons = this.groupCouponHandle(
        this.coupons.filter(item => item.name.toLowerCase().includes(this.couponString.toLowerCase()))
      );
    } else {
      this.filterCoupons = this.groupCouponHandle(cloneDeep(this.coupons));
    }
  }
  selectCouponHandle(item) {
    if (this.selectedCoupon.id === item.id && (!this.withGroup || this.selectedCoupon.group === item.group)) {
      this.selectedCoupon = {};
    } else {
      this.selectedCoupon = item;
    }
    this.onSelectCoupon(this.selectedCoupon)
  }
}
